import { moveTile, removeTile, setTileHidden } from '../data/commands/tiles';
import { useCommandEnv } from '../data/hooks';
import { Button } from '../ui/Button';
import { Sheet } from '../ui/Sheet';
import type { TileRow } from './layout';
import { getTileDef } from './registry';

export interface TileActionsSheetProps {
  tileId: string | null;
  list: TileRow[];
  onClose(): void;
  onOpenSettings(id: string): void;
}

export function TileActionsSheet({ tileId, list, onClose, onOpenSettings }: TileActionsSheetProps) {
  const env = useCommandEnv();
  const index = list.findIndex((r) => r.id === tileId);
  const row = index >= 0 ? list[index] : null;
  const def = row ? getTileDef(row.type) : undefined;
  return (
    <Sheet
      open={row !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={def?.title ?? 'Tile'}
    >
      {row && def ? (
        <div className="flex flex-col gap-2">
          <Button
            disabled={index === 0}
            onClick={() => void moveTile(env, list, row.id, index - 1)}
          >
            Move up
          </Button>
          <Button
            disabled={index === list.length - 1}
            onClick={() => void moveTile(env, list, row.id, index + 1)}
          >
            Move down
          </Button>
          <Button
            onClick={async () => {
              await setTileHidden(env, row.id, !row.hidden);
              onClose();
            }}
          >
            {row.hidden ? 'Show on Today' : 'Hide from Today'}
          </Button>
          {def.Settings ? (
            <Button onClick={() => onOpenSettings(row.id)}>Tile settings</Button>
          ) : null}
          <Button
            variant="destructive"
            onClick={async () => {
              await removeTile(env, row.id);
              onClose();
            }}
          >
            Remove
          </Button>
          <p className="text-xs text-muted">
            Hidden tiles stay here in edit mode. Removing takes the tile off Today; your data stays.
          </p>
        </div>
      ) : null}
    </Sheet>
  );
}
